// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gL88","col":"styles_col__SW9nc","actions":"styles_actions__3Ysu-","conflict":"styles_conflict__NJw_O"};